var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisconnectfromthisuser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Disconnect_from_this_user",
    "data-name": "Disconnect from this user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.502,
    height: 26.406,
    viewBox: "0 0 25.502 26.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_48",
    "data-name": "Subtra\\xE7\\xE3o 48",
    d: "M9.421,23.815h0a13.3,13.3,0,0,1-6.268-1.448A5.468,5.468,0,0,1,0,17.567v-.9A2.37,2.37,0,0,1,2.361,14.29H11.34a8.769,8.769,0,0,0-1.921,9.525ZM9.5,11.907a5.953,5.953,0,1,1,5.939-5.953A5.955,5.955,0,0,1,9.5,11.907Z",
    fill: "#cbdaee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "broken-link",
    d: "M4.4,0a.584.584,0,0,0-.486.94l.876,1.167a.584.584,0,1,0,.934-.7L4.845.24A.584.584,0,0,0,4.4,0ZM8.486,0A.584.584,0,0,0,8,.24L7.122,1.408a.584.584,0,1,0,.934.7L8.931.94A.584.584,0,0,0,8.486,0ZM3.21,2.925a3.21,3.21,0,0,0,0,6.421H4.378a.584.584,0,1,0,0-1.168H3.21a2.043,2.043,0,0,1,0-4.086H4.378a.584.584,0,1,0,0-1.168Zm5.253,0a.584.584,0,1,0,0,1.168H9.631a2.043,2.043,0,0,1,0,4.086H8.464a.584.584,0,1,0,0,1.168H9.631a3.21,3.21,0,0,0,0-6.421Zm-3.189,7a.584.584,0,0,0-.489.24l-.876,1.167a.584.584,0,1,0,.934.7l.876-1.167a.584.584,0,0,0-.445-.94Zm2.333,0a.584.584,0,0,0-.486.94L8,12.031a.584.584,0,1,0,.934-.7l-.876-1.167a.584.584,0,0,0-.447-.24Z",
    transform: "translate(12.16 13.625)",
    fill: "#8ba5c9",
    stroke: "#8ba5c9",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectfromthisuser);
export default __webpack_public_path__ + "static/media/Disconnect from this user.6e0affdf.svg";
export { ForwardRef as ReactComponent };